export const SESSION_STORAGE_KEYS = Object.freeze({
  TOKEN: "Token",
  SESSION_ID: "SessionID",
  ENTITY_ID: "EntityID",
  ENTITY_TYPE: "EntityType",
  LEGAL_ENTITY_ID: "LegalEntityID",
  EMPLOYEE_ID: "EmployeeID",
  USER_NAME: "UserName",
  WEB_KEY: "webKey",
  MOBILE_TOKEN: "TokenMobile",
  MOBILE_SESSION: "SessionMobile",
  FEATURES: "Features",
  TABS: "Tabs",
  SIDEBAR_PAGES: "SidebarPages",
  ENTITIES: "Entities",
  MERCHANTS: "Merchants",
  REG_CODE_URL: "RegCodUrl",
  ENCRYPTED_WEBSOCKET_URL: "encryptedWebSocketUrl",
  S2S_TRANSFER_TEMPLATE: "S2sTransferTemplate",
});

export function readSessionStorageValue(key, fallback = "") {
  try {
    const value = sessionStorage.getItem(key);
    return value ?? fallback;
  } catch {
    return fallback;
  }
}

export function readSessionStorageNumber(key, fallback = 0) {
  const value = Number(readSessionStorageValue(key, ""));
  return Number.isFinite(value) ? value : fallback;
}
